export default __webpack_public_path__ + "static/media/verfilink.fafd98de.png";